import { useEffect, useState } from "react";
import { Link } from "wouter";
import {
  INDEX_SYMBOL,
  fmtSol,
  fmtTime,
  loadLotteryHistory,
  shortMint,
} from "../lib/data";
import LotteryCountdown from "../components/LotteryCountdown";

function solscanTx(sig) {
  return sig ? `https://solscan.io/tx/${sig}` : null;
}

function solscanAccount(addr) {
  return addr ? `https://solscan.io/account/${addr}` : null;
}

export default function LotteryPage({ data }) {
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState(null);
  const lottery = data?.lottery;
  const schedule = data?.schedule || {};
  const pct = lottery?.lotteryPct ?? schedule.lotteryPct ?? 10;

  useEffect(() => {
    loadLotteryHistory()
      .then((h) => setRows(h.versions))
      .catch((e) => setErr(e.message));
  }, []);

  return (
    <section className="app-section" style={{ paddingTop: "2.5rem" }}>
      <div className="shell">
        <p className="section-kicker">
          <i className="brand-diamond" aria-hidden /> Lottery
        </p>
        <h2 className="section-title">Holder lottery</h2>
        <p className="section-lead left">
          {`~${pct}% of each $${INDEX_SYMBOL} fee cycle funds a SOL pot. Draws hit on a random ${lottery?.intervalMin ?? 20}–${lottery?.intervalMax ?? 60} minute cadence. One ticket per eligible holder — balance does not change your odds.`}
        </p>

        <div className="portfolio-summary" style={{ marginTop: 0 }}>
          <div className="portfolio-stat">
            <div className="label">Current pot</div>
            <strong>
              {lottery?.potSol != null ? `${fmtSol(lottery.potSol)} SOL` : "—"}
            </strong>
            <p>~{pct}% of each spend cycle</p>
          </div>
          <div className="portfolio-stat">
            <div className="label">Draws</div>
            <strong>{lottery?.drawCount ?? 0}</strong>
            <p>Equal-odds winners</p>
          </div>
          <div className="portfolio-stat">
            <div className="label">Last winner</div>
            <strong style={{ fontSize: "1.05rem" }}>
              {lottery?.lastWinner?.address
                ? shortMint(lottery.lastWinner.address, 4)
                : "—"}
            </strong>
            <p>
              {lottery?.lastWinner?.amountSol != null
                ? `${fmtSol(lottery.lastWinner.amountSol)} SOL`
                : "No draws yet"}
            </p>
          </div>
          <div className="portfolio-stat lottery-stat-cd">
            <LotteryCountdown lottery={lottery} compact />
            <p style={{ marginTop: "0.5rem" }}>
              Next window · {lottery?.intervalMin ?? 20}–{lottery?.intervalMax ?? 60}m
            </p>
          </div>
        </div>

        {err && <p className="error">{err}</p>}
        {!rows && !err && <p className="loading">Loading winners…</p>}

        {rows && rows.length === 0 && (
          <div className="panel">
            <h3>No winners yet</h3>
            <p>
              The pot fills as spend cycles run. When the random draw clock fires
              and the pot clears the minimum, one eligible holder receives the
              full pot in SOL.
            </p>
            <Link href="/cycles" className="btn btn-ghost">
              View fee cycles
            </Link>
          </div>
        )}

        {rows && rows.length > 0 && (
          <div className="history-grid">
            {rows.map((d) => (
              <article className="history-card cycle-card" key={d.version}>
                <div className="history-card__top">
                  <strong>Draw #{d.version}</strong>
                  <span>{fmtTime(d.createdAt)}</span>
                </div>
                <div className="cycle-meta">
                  <span>
                    Winner{" "}
                    <b>
                      <a
                        href={solscanAccount(d.winner)}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {shortMint(d.winner, 4)}
                      </a>
                    </b>
                  </span>
                  <span>
                    Won <b>{fmtSol(d.amountSol)} SOL</b>
                  </span>
                  <span>
                    Tickets <b>{d.eligibleCount ?? "—"}</b>
                    {d.equalOdds !== false ? " · equal odds" : ""}
                  </span>
                </div>
                {d.signature ? (
                  <p className="cycle-sigs">
                    <a href={solscanTx(d.signature)} target="_blank" rel="noreferrer">
                      Solscan payout
                    </a>
                  </p>
                ) : null}
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
